import React, { createContext, useContext, useEffect, useState } from "react";
import Translate from "./TranslateData.json";
const ContextOpen = createContext({});

window.localStorage.getItem("language")
  ? window.localStorage.getItem("language")
  : window.localStorage.setItem("language", "en");

const ContextProvider = ({ children }) => {
  const [swiperIndex, setSwiperIndex] = useState("");
  const [direction, setDirection] = useState("");
  const [translate, setTranslate] = useState(
    window.localStorage.getItem("language")
  );
  const [content, setContent] = useState({});
  const [showPopUp, setShowPopUp] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (window.localStorage.getItem("language") === "ar") {
      setDirection("rtl");
      setContent(Translate.ar);
    }
    if (window.localStorage.getItem("language") === "en") {
      setDirection("ltr");
      setContent(Translate.en);
    }
  }, [translate, content]);

  const changeLanguage = () => {
    setTranslate("ar");
    window.location.reload();
    window.localStorage.setItem("language", "ar");
  };
  const changeLanguage2 = () => {
    setTranslate("en");
    window.location.reload();
    window.localStorage.setItem("language", "en");
  };

  return (
    <ContextOpen.Provider
      value={{
        showPopUp,
        setShowPopUp,
        content,
        changeLanguage,
        changeLanguage2,
        swiperIndex,
        setSwiperIndex,
        successMessage,
        setSuccessMessage,
        direction,
      }}
    >
      {children}
    </ContextOpen.Provider>
  );
};

export default ContextProvider;

export const useContextHook = () => {
  return useContext(ContextOpen);
};
